module.exports = __webpack_public_path__ + "img/fox.1dc7b6e.png";